<script setup lang="ts">
import type { TooltipProviderProps } from 'reka-ui';
import { TooltipProvider as TooltipProviderPrimitive } from 'reka-ui';

defineOptions({
    name: 'UiTooltipProvider',
});

const props = withDefaults(defineProps<TooltipProviderProps>(), {
    delayDuration: 100,
    skipDelayDuration: 200,
    disableHoverableContent: true,
});
</script>

<template>
    <TooltipProviderPrimitive v-bind="props">
        <slot />
    </TooltipProviderPrimitive>
</template>
